<template>
    <div class="fixed inset-0 z-0" :class="{ 'animate-ocean-swell': isHome }">
        <img
            src="@/img/water-1920.webp"
            alt=""
            class="h-full w-full object-cover opacity-60"
            :class="{ 'animate-ocean-breathe': isHome }"
        />

        <div class="absolute inset-0 bg-gradient-to-b from-void/40 via-transparent to-void" />
    </div>

    <div class="relative z-10 flex min-h-svh flex-col">
        <nav-bar />

        <div class="main flex flex-1 text-base font-light sm:pt-4 sm:text-lg">
            <router-view />
        </div>

        <footer-bar />
    </div>

    <content-preloader />
</template>

<script>
    // Library
    import { computed, defineComponent } from 'vue';
    import { useRoute } from 'vue-router';

    // Components
    import NavBar from '@/components/layout/NavBar';
    import FooterBar from '@/components/layout/FooterBar';
    import ContentPreloader from '@/components/ContentPreloader';

    export default defineComponent({
        name: 'App',

        components: {
            NavBar,
            FooterBar,
            ContentPreloader,
        },

        setup() {
            const route = useRoute();

            return {
                isHome: computed(() => route.name === 'home'),
            };
        },
    });
</script>
